import React, { FC }          from "react";
import { Form, Input }        from "semantic-ui-react";
import Address                from "../../../domain/fundamentals/address/Address";
import Building               from "../../../domain/fundamentals/address/Building";
import City                   from "../../../domain/fundamentals/address/City";
import PostalCode             from "../../../domain/fundamentals/address/PostalCode";
import Prefecture             from "../../../domain/fundamentals/address/Prefecture";
import Street                 from "../../../domain/fundamentals/address/Street";
import ValidatorMessage       from "../message/ValidatorMessage";
import PostalCodeSearchButton from "./PostalCodeSearchButton";

interface Props {
  isGroup?: boolean;
  address: Address;
  setPostalCode: (postalCode: PostalCode) => void;
  setPrefecture: (prefecture: Prefecture) => void;
  setCity: (city: City) => void;
  setStreet: (street: Street) => void;
  setBuilding: (building: Building) => void;
}

const AddressFormField: FC<Props> = (props: Props) => {
  if (props.isGroup) {
    return (
      <>
        <Form.Group>
          <Form.Field>
            <label>郵便番号</label>
            <Input
              value={ props.address.postalCode.value }
              onChange={ (event, data) => props.setPostalCode(new PostalCode(data.value)) }
            />
            <ValidatorMessage target="address.postal_code"/>
          </Form.Field>
          <Form.Field>
            <label>&nbsp;</label>
            <PostalCodeSearchButton
              postalCode={ props.address.postalCode }
              setPrefecture={ props.setPrefecture }
              setCity={ props.setCity }
              setStreet={ props.setStreet }
            />
          </Form.Field>
        </Form.Group>

        <Form.Group>
          <Form.Field>
            <label>都道府県</label>
            <Input
              value={ props.address.prefecture.value }
              onChange={ (event, data) => props.setPrefecture(new Prefecture(data.value)) }
            />
            <ValidatorMessage target="address.prefecture"/>
          </Form.Field>
        </Form.Group>

        <Form.Group>
          <Form.Field>
            <label>市区町村</label>
            <Input
              value={ props.address.city.value }
              onChange={ (event, data) => props.setCity(new City(data.value)) }
            />
            <ValidatorMessage target="address.city"/>
          </Form.Field>
        </Form.Group>

        <Form.Group>
          <Form.Field>
            <label>住所</label>
            <Input
              value={ props.address.street.value }
              onChange={ (event, data) => props.setStreet(new Street(data.value)) }
            />
            <ValidatorMessage target="address.street"/>
          </Form.Field>
        </Form.Group>

        <Form.Group>
          <Form.Field>
            <label>番地・ビル</label>
            <Input
              value={ props.address.building.value }
              onChange={ (event, data) => props.setBuilding(new Building(data.value)) }
            />
            <ValidatorMessage target="address.building"/>
          </Form.Field>
        </Form.Group>
      </>
    )
  }

  return (
    <>
      <Form.Field>
        <label>
          <span style={{marginRight: "1rem"}}>郵便番号</span>
          <PostalCodeSearchButton
            postalCode={ props.address.postalCode }
            setPrefecture={ props.setPrefecture }
            setCity={ props.setCity }
            setStreet={ props.setStreet }
          />
        </label>
        <Input
          defaultValue={ props.address.postalCode.value }
          onChange={ (event, data) => props.setPostalCode(new PostalCode(data.value)) }
        />
        <ValidatorMessage target="address.postal_code"/>
      </Form.Field>
      <Form.Field>
        <label>都道府県</label>
        <Input
          defaultValue={ props.address.prefecture.value }
          onChange={ (event, data) => props.setPrefecture(new Prefecture(data.value)) }
        />
        <ValidatorMessage target="address.prefecture"/>
      </Form.Field>
      <Form.Field>
        <label>市区町村</label>
        <Input
          defaultValue={ props.address.city.value }
          onChange={ (event, data) => props.setCity(new City(data.value)) }
        />
        <ValidatorMessage target="address.city"/>
      </Form.Field>
      <Form.Field>
        <label>住所</label>
        <Input
          defaultValue={ props.address.street.value }
          onChange={ (event, data) => props.setStreet(new Street(data.value)) }
        />
        <ValidatorMessage target="address.street"/>
      </Form.Field>
      <Form.Field>
        <label>番地・ビル</label>
        <Input
          defaultValue={ props.address.building.value }
          onChange={ (event, data) => props.setBuilding(new Building(data.value)) }
        />
        <ValidatorMessage target="address.building"/>
      </Form.Field>
    </>
  );
};

export default AddressFormField;
